module.exports = __webpack_public_path__ + "img/brett-jordan-LPZy4da9aRo-unsplash.123dbe56.jpg";